<button type="button" class="btn btn-{{class}}" [ngClass]="{active: toggled,'btn-sm': small}" container="body" [ngbTooltip]="tooltip"
  (click)="click();$event.stopPropagation()">
   <i *ngIf="!toggled" class="far fa-square"></i>
   <i *ngIf="toggled" class="far fa-check-square"></i>&nbsp;{{caption}}
</button>
